export default __webpack_public_path__ + "static/media/TOR.e7ed640e.svg";